import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import { SwiperClass } from "core/classes/swiper/swiper.class";
import { MediaQueryPublisher } from "core/classes/media.query.publisher.class";

// on load because of wallpaper adverts - need to wait until they've loaded
// see NWP-120
$(window).on("load", function() {
  if (!Abacus.PreventDefault.PicCarousel &&
    !$(".picCarousel").hasClass("initialized")
) {
  $(".picCarousel").each(function() {
    Abacus.PicCarousel = new PicCarousel(this);
    this.classList.add("initialized");
  });
}
});


let PicCarouselOptions = {
  caption: ".caption",
  captionLink: ".caption .heading > a",
  displayLink: ".display > a",
  activeThumbClass: "selected",
  thumbs: ".thumbs li",
  gallery: ".galleryItems",
  pagingSelector: ".carouselPaging li",
  swiper: {
    autoplay: true,
    loop: true,
    roundLengths: true
  }
};

class PicCarousel extends Class {
  constructor(element, mqp, options) {
    super();
    this.element = $(element);
    this.mediator = $({});
    this.setOptions(PicCarouselOptions, options);
    this.setUpElements();
    this.setupPreEvents();
    this.mqp = mqp;
    this.swiper = new SwiperClass(this.element, this.mediator, {
      swiperContainer: this.options.gallery,
      swiper: this.options.swiper
    });
   
 
   
    this.setupEvents();
    this.paused = false;
    this.init();
  }

  init() {
    if (this.swiper) return;
}


  setupPreEvents() {
    var self = this;

    this.mediator.on("swiperLoaded", function(evt, element) {
      setTimeout(function() {
        self.pagingPosition();
      }, 250);
    });
  }

  setUpElements() {
    this.thumbs = this.element.find(this.options.thumbs);
    this.galleryItems = this.element.find(this.options.gallery); 
    //find all the possible focusable items and add a tabindex -1 so they won't be focusable when tabbing through
    var galNoFocus = this.galleryItems.find('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
    galNoFocus.each(function(){
      $(this).attr('tabindex', '-1');
    })
  }
  setupEvents() {
    var self = this,
      toSlide = false;

    //whenever the swiper updates, update the thumbnails
    //unless a specific thumbnail has been clicked

    this.swiper.swiper.on("slideChange", function() {
      var index = self.swiper.swiper.realIndex;
      var scrollerSlide = $(self.thumbs.get(index));
      self.thumbs.removeClass(self.options.activeThumbClass);
      scrollerSlide.addClass(self.options.activeThumbClass);
    });

    //thumbnail click / focus - select correct gallery item
    this.thumbs.on("click focus", function(e) {
      self.paused = true;
      self.swiper.stopAutoplay();
      var index = $(this).index() + 1;
      self.swiper.goToSlide(index);
    });
    //on thumb enter goes to current/selected article
    this.thumbs.on("keypress", function(e) {
      e.preventDefault();
      var index = $(this).index() + 1;
      var currentLink = self.element.find('h2 > a').eq(index + 1);
      if(e.code = 'Enter'){
        window.location = currentLink.attr('href')
      }
    })
    // paging (prev / next)
    this.element
      .find(this.options.pagingSelector)
      .off()
      .on("click", function(evt) {
        evt.preventDefault();
        self.paused = true;
        self.swiper.stopAutoplay();
        if ($(this).hasClass("previous")) {
          self.swiper.previous();
        } else {
          self.swiper.next();
        }
      });

    //when hovering on the swiper, pause
    this.galleryItems.on({
      mouseenter: function() {
        self.swiper.stopAutoplay();
      },
      mouseleave: function() {
        if (!self.paused) {
          self.swiper.startAutoplay();
        }
      }
    });

    $(window).on("orientationchange", function() {
      self.pagingPosition();
    });
  }

  pagingPosition() {
    var imageHeight = this.element.find(".picture").outerHeight(),
      topPosition =
        imageHeight - this.element.find(this.options.pagingSelector).height();

    this.element
      .find(this.options.pagingSelector)
      .remove("style")
      .css("top", topPosition / 2 + "px");
  }
}

export { PicCarousel };



// WEBPACK FOOTER //
// ./Javascript/core/classes/spin2/pic.carousel.class.js